/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LayoutStyleType = {
    Stack: 'Stack',
    Relative: 'Relative'
} as const;
export type LayoutStyleType = typeof LayoutStyleType[keyof typeof LayoutStyleType];

